const getSortDirection = (sorter, field) => {
  if (!sorter || sorter.field !== field) return "none"
  return sorter.order === "ascend" ? "ascending" : "descending"
}

const getHeaders = (sorter) => [
  {
    title: "ID",
    dataIndex: "booking_id",
    key: "booking_id",
    width: 130,
    ellipsis: true
  },
  {
    title: "Experience",
    dataIndex: "experience",
    key: "experience",
    sorter: true,
    width: 150,
    ellipsis: true,
    "aria-sort": getSortDirection(sorter, "experience")
  },
  {
    title: "Date & Time",
    dataIndex: "booked_date",
    key: "booked_date",
    width: 180,
    ellipsis: false
  },
  {
    title: "Guests",
    dataIndex: "guests",
    key: "guests",
    width: 90,
    ellipsis: false,
    align: "center"
  },
  {
    title: "Payment",
    dataIndex: "payment",
    key: "payment",
    sorter: true,
    width: 130,
    ellipsis: false,
    align: "center",
    "aria-sort": getSortDirection(sorter, "payment_status")
  },
  {
    title: "Docs",
    dataIndex: "docs",
    key: "docs",
    sorter: true,
    width: 110,
    ellipsis: false,
    "aria-sort": getSortDirection(sorter, "docs")
  },
  {
    title: "Crew",
    dataIndex: "crew",
    key: "crew",
    width: 180,
    ellipsis: false
  },
  {
    title: "Resources",
    dataIndex: "resources",
    key: "resources",
    width: 260,
    ellipsis: false
  },
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    width: 60
  }
]

export { getHeaders }
